import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Rightmenu from "../Mainpage/Rightmenu/Rightmenu";
import { editPost, editPostSub } from "../store";

function Edit() {
    
    


    // Leftpost에서 받아온 배열의 번호(i)값
    const {state} = useLocation()
    console.log('받아온값',state)
    
    let dispatch = useDispatch()
    let navigate = useNavigate()    
    let rStore = useSelector((state)=>{return state})
    console.log('포스트제목:',rStore.postSub[state],'포스트내용:', rStore.post[state])
    return(
        <div>
        <Container style={{marginTop:'30px'}}>
            <Row>
                <Col xs={8}><EditOne></EditOne></Col>
                <Col xs={4}><Rightmenu></Rightmenu></Col>
            </Row>
        </Container>
    </div>
    )

    let useId
    let useTime 

    if(state===null) {
        let writed = localStorage.getItem('writed')
        let useArray = JSON.parse(writed)
        console.log('useTime',useArray[0][0],useArray[0][3])
        useId = useArray[0][0]
        useTime = useArray[0][3]
        
    }else {
        let writed = localStorage.getItem('writed')
        let useArray = JSON.parse(writed)
        
        console.log('useTime',useArray[state][0],useArray[state][3])
        useId = useArray[state][0]
        useTime = useArray[state][3]
    }


    function EditOne() {
    
        // 만일 state가 unll이라면, state를 0으로 바꿔서 저장하라

        let beforeSub
        let beforePost

        if (state===null) {
            let writed = localStorage.getItem('writed')
            let writedarray = JSON.parse(writed)
            beforeSub = writedarray[0][1]
            beforePost = writedarray[0][2]
        } else {
            let writed = localStorage.getItem('writed')
            let writedarray = JSON.parse(writed)
            beforeSub = writedarray[state][1]
            beforePost = writedarray[state][2]
        }

        
        const [inputPostName, setInputPostName] = useState(beforeSub)
        const [inputPost, setInputPost] = useState(beforePost)
      
          return(
              <div>
                  <div>
                    <input className="포스트 제목" style={{width:"100%",height:"50px"}}                    
                    defaultValue={beforeSub}
                    onChange={(e)=>{   
                      setInputPostName(e.target.value)
                    }}
                    ></input>
                  </div>
                  <input className="날짜" style={{height:'20px'}} type="hidden" disabled></input>
                  <div>
                   <input className="글 내용" style={{width:"100%", height:"100px"}}
                   defaultValue={beforePost}
                   onChange={(e)=>{
                    setInputPost(e.target.value)
                  }}  ></input>
                  </div>
                  <Button variant="dark" onClick={()=>{
                    // 변경된 내용으로 redux 제목과 내용을 변경하라
                    dispatch(editPostSub({arrayNumber:state,postSub:inputPostName})) 
                    dispatch(editPost({arrayNumber:state,post:inputPost}))    
                    
                    // 변경된 내용으로 localStorage 제목과 내용을 변경하고 시간과 포스트 아이디는 유지해..
                    let writed = localStorage.getItem('writed')
                    let writedarray = JSON.parse(writed)
                    
                    console.log('로컬에서꺼낸거',writedarray)
                   
                    console.log('아이디,제목,내용,시간')

                    if (state===null){
                        console.log(useTime[0][0],inputPostName,inputPost,useTime[0][3])
                        writedarray.splice([0][0],1,[useId,inputPostName,inputPost,useTime])
                        console.log('최종',writedarray)
                        localStorage.setItem('writed',JSON.stringify(writedarray))
                    } else {
                    console.log(rStore.countPost[state],inputPostName,inputPost,rStore.postDay[state]) 
                    writedarray.splice([state][0],1,[rStore.postId[state],inputPostName,inputPost,rStore.postDay[state]])
                    console.log('최종',writedarray)
                    localStorage.setItem('writed',JSON.stringify(writedarray))
                    }              

                    // 최종
                    console.log(localStorage.getItem('writed'))

                    navigate('/')
                    }}>제출</Button>
              </div>
          )
      }
      

}


export default Edit